import React from 'react';
import InputSquare from './InputSquare';
import { TriwordStore } from '../../TriwordStore';

const SolutionInput = () => {
  const { numInputs } = TriwordStore.useState();

  const inputSquares = Array.from({ length: numInputs }, (_, i) => (
    <InputSquare key={i} position={i} />
  ));

  return (
    <>
      {inputSquares}
    </>
  );
};

export default SolutionInput;